import React from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import FieldDisplay from "../common/FieldDisplay";
import {
  getFieldName,
  getFieldDate,
  getFieldTime,
  getFieldFormattedValue,
} from "../../scripts/helperScripts";

const SOARCorrespondenceCard = ({ correspondence }) => {
  return (
    <>
      <Card className="card-safy">
        <Card.Header className="bg-safy1-1" style={{ color: "white" }}>
          <div className="row">
            <div className="col-10">{correspondence.sor_name}</div>
            <div className="col-2">
              <div className="float-end">
                <Link
                  title="SOAR Correspondence"
                  to="/correspondence"
                  state={{
                    correspondence: { correspondence },
                    tab: "correspondence",
                  }}
                >
                  <i
                    className="fas fa-pen float-end p-2"
                    style={{ color: "#FFFFFF" }}
                  ></i>
                </Link>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="card-body-safy">
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 mb-4">
            <div className="col">
              <FieldDisplay
                label="Date:"
                value={getFieldDate(correspondence.sor_dateandstarttime)}
              />
              <FieldDisplay
                label="Start Time:"
                value={getFieldTime(correspondence.sor_dateandstarttime)}
              />
              <FieldDisplay
                label="Minutes:"
                value={getFieldFormattedValue(correspondence.sor_minutes)}
              />
              <br />
              <FieldDisplay
                label="Service Recipients"
                value={getFieldName(correspondence.sor_servicerecipients)}
              />
            </div>
            <div className="col">
              <FieldDisplay
                label="Delivery Method:"
                value={getFieldName(correspondence.sor_deliverymethod)}
              />
              <FieldDisplay
                label="Place of Service:"
                value={getFieldName(correspondence.sor_placeofservice)}
              />
              <FieldDisplay
                label="Service Status:"
                value={getFieldName(correspondence.sor_servicestatus)}
              />
            </div>
          </div>
          {correspondence.sor_progressnote && (
            <div
              className="p-2 mt-4 mb-4 w-100 h-100"
              style={{ backgroundColor: "white", whiteSpace: "pre-wrap" }}
            >
              {correspondence.sor_progressnote}
            </div>
          )}

          <FieldDisplay
            label="Signed:"
            value={getFieldName(correspondence.sor_esignuser)}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default SOARCorrespondenceCard;
